import Vue from 'vue'
import VueRouter from 'vue-router'

import Admin from '@/views/admin'
import Administrators from '@/views/administrators'
import Calendar from '@/views/calendar'
import Masters from '@/views/masters/index'
import Engineers from '@/views/engineers'
import Clients from '@/views/clients'
import Chat from '@/views/chat'
import Offices from '@/views/offices'
import Tags from '@/views/tags'

import Services from '@/views/services/services'
import ServiceMaterial from '@/views/services/serviceMaterial'
import ServiceRoot from '@/views/services/index'

import AdminRequest from '@/views/adminRequests'
import Orders from '@/views/orders'
import Partners from '@/views/partners'
import Todo from '@/views/todo'
import pdfFiles from '@/views/pdfFiles'

import Login from '@/views/login'
import entryAdmin from '@/components/layout/entryAdmin'
import isLogged from '@/helpers/api/isLogged'

import {
    i18n,
} from '@/plugins/vuei8n'
import _4screen from '../views/_4screen'
import _form from '../views/_form'

import Dashboard from '../views/dashboard'

Vue.use(VueRouter)
const app = new Vue({
    i18n,
})

const routes = [{
    path: '/',
    component: entryAdmin,
    redirect: () => '/admin/orders',
    children: [{
        name: 'Admin',
        path: '/admin',
        component: Admin,
        meta: {
            guard: 'Admin',
        },
    }, {
        name: '_4screen',
        path: '/_4screen',
        component: _4screen,
        meta: {
            guard: '_4screen',
        },
    }, {
        name: '_form',
        path: '/_form',
        component: _form,
        meta: {
            guard: '_form',
        },
    }, {
        name: 'All',
        path: '/admin/all',
        component: _4screen,
        meta: {
            guard: 'All',
        },
    }, {
        path: '/admin/dashboard',
        component: Dashboard,
        meta: {
            guard: 'Dashboard',
        },
    },
    {
        path: '/admin/pdf',
        component: pdfFiles,
        meta: {
            guard: 'pdfFiles',
        },
    },
    {
        path: '/admin/administrators',
        component: Administrators,
        meta: {
            guard: 'Administrators',
        },
    }, {
        name: 'calendar',
        path: '/admin/calendar',
        component: Calendar,
        meta: {
            guard: 'Calendar',
        },
    }, {
        name: 'master-calendar',
        path: '/admin/calendar',
        component: Calendar,
        meta: {
            guard: 'Calendar',
        },
    }, {
        name: 'orders',
        path: '/admin/orders',
        component: Orders,
        meta: {
            guard: 'Orders',
        },
    }, {
        name: 'tags',
        path: '/admin/tags',
        component: Tags,
        meta: {
            guard: 'Tags',
        },
    }, {
        name: 'offices',
        path: '/admin/offices',
        component: Offices,
        meta: {
            guard: 'Offices',
        },
    }, {
        path: '/admin/masters',
        component: Masters,
        meta: {
            guard: 'Masters',
        },
    }, {
        path: '/admin/admin',
        component: Admin,
        meta: {
            guard: 'Admin',
        },
    }, {
        path: '/admin/engineers',
        name: 'engineers',
        component: Engineers,
        meta: {
            guard: 'Engineers',
        },
    }, {
        name: 'clients',
        path: '/admin/clients',
        component: Clients,
        meta: {
            guard: 'Clients',
        },
    }, {
        name: 'chat',
        path: '/admin/chat',
        component: Chat,
        meta: {
            guard: 'Chat',
        },
    }, {
        path: '/admin/services',
        component: ServiceRoot,
        children: [{
            path: '',
            component: Services,
            meta: {
                guard: 'Services',
            },
        },
        {
            path: ':id/materials',
            name: 'ServiceMaterial',
            component: ServiceMaterial,
            meta: {
                breadcrumbs: [{
                    name: app.$t('navigation.main'),
                    link: '/admin',
                },
                {
                    name: app.$t('navigation.services'),
                    link: '/admin/services',
                },
                ],
                guard: 'Materials',
            },
            props: true,
        },
        ],
    }, {
        path: '/admin/requests',
        name: 'Requests',
        component: AdminRequest,
        meta: {
            guard: 'Requests',
        },
    }, {
        path: '/admin/partners',
        component: Partners,
        meta: {
            guard: 'Partners',
        },
    }, {
        name: 'todo',
        path: '/admin/todo',
        component: Todo,
        meta: {
            guard: 'Todo',
        },
    },
    ],
},
{
    path: '/auth/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
        if (isLogged()) {
            next('/admin/orders')
        }

        next()
    },
},
{
    path: '*',
    redirect: () => (isLogged()
        ? '/admin/orders' : '/auth/login'),
},
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

router.beforeEach((to, from, next) => {
    window.layout = 'default'

    next()
})
window.$router = router

export default router
